import { Button, Form, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getInternshipById,
  updateInternshipById,
} from "store/slices/internshipsSlice";
import { closeModal } from "store/slices/modalsSlice";
import { getSchools } from "store/slices/schoolsSlice";
import InternshipForm from "./internship-form";

const EditInternshipModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { loading, internship } = useSelector((state) => state?.internships);
  const { schools } = useSelector((state) => state?.schools);
  const open = isModalOpen && modalType === "edit_internship";
  const { userData } = useSelector((state) => state?.auth);
  const internshipId = modalProps?.internshipId;

  useEffect(() => {
    if (open && internshipId && userData?._id) {
      if (userData?._id) dispatch(getSchools(userData?._id));
      dispatch(getInternshipById(internshipId));
    }
  }, [dispatch, open, userData?._id, internshipId]);

  useEffect(() => {
    if (open && internship) {
      form?.setFieldsValue({
        ...internship,
        startingDate: dayjs(internship?.startingDate),
      });
    }
  }, [open, internship, schools, form]);

  const onSubmit = async (values) => {
    if (values?.startingDate) {
      values.startingDate = dayjs(values?.startingDate)?.format("YYYY-MM-DD");
    }

    return await dispatch(
      updateInternshipById({
        internshipId,
        data: values,
      })
    )?.unwrap()?.then(() => {
        notification?.success({
          message: t("common.success"),
          description: t("internships.notif.updatedSuccess"),
        });
        onClose();
      })?.catch((error) => {
        notification?.error({
          message: t("common.error"),
          description: error?.message,
        });
      });
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={
        <h4 style={{ textAlign: "center" }}>{t("internships.crud.edit")}</h4>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("common.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="internship_form"
          disabled={loading}
        >
          {t("common.update")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <InternshipForm form={form} schools={schools} onSubmit={onSubmit} />
    </Modal>
  );
};

export default EditInternshipModal;
